import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import ShopEntryPoints from '#app/entrypoints/shop';
import { Option } from '#app/typings/utils';

type HookReturn = {
  shops: Option[];
};

const useShops = (): HookReturn => {
  const { data: shops } = useSWR<Option[]>(generateApiPath(ShopEntryPoints.getSelect), getCollection, {
    revalidateOnFocus: false,
  });

  return {
    shops: shops ?? [],
  };
};

export default useShops;
